
<mat-card class="summary-card" fxLayout="row wrap" fxLayoutAlign="start stretch" style="width: 100%;">
    <mat-card-content fxLayout="row wrap" fxLayoutAlign="start stretch" style="width: 100%;">

        <div *ngFor="let item of summaryItems"
            class="summary-item"
            fxLayout="row"
            fxLayoutAlign="start center"
            fxFlex="20%" fxFlex.lt-md="50%" fxFlex.lt-sm="100%">

            <!-- Icon -->
            <div *ngIf="item.icon !== 'custom'"
                class="summary-icon"
                fxLayoutAlign="center center"
                [ngStyle]="{
                    'background-color':
                        item.color === 'green' ? '#e8f5e9' :
                        item.color === 'red' ? '#fdecea' : '#e3f2fd'
                }">
                <mat-icon
                    [ngStyle]="{
                        'color':
                            item.color === 'green' ? '#2e7d32' :
                            item.color === 'red' ? '#c62828' : '#1565c0'
                    }">
                    {{ item.icon }}
                </mat-icon>
            </div>

            <div *ngIf="item.icon === 'custom'" class="summary-icon-custom" fxLayoutAlign="center center">
                <img src="assets/img/prof.png" height="25" width="25" alt="prof.png">
            </div>

            <!-- Text -->
            <div class="summary-text" fxLayout="column">
                <div class="summary-value">
                    {{ dataList[item.key] }}{{ item.suffix || '' }}
                </div>
                <div class="summary-label">
                    {{ item.label }}
                </div>
            </div>

        </div>

    </mat-card-content>
</mat-card>
